<div class="modal-header">
    <h5 class="pt-4" style="padding-left:2.5rem">Historial de movimientos</h5>
    <button type="button" class="btn-close me-4" mat-dialog-close></button>
</div>
<mat-dialog-content class="mat-typography">
    <div class="modal-body">
        <div class="container">
            <div class="row">
                <div class="col-md-12 table-wrapper">
                    <div class="timeline-container">
                        <ul class="timeline mt-2">
                            <li class="timeline-item" *ngFor="let hist of historial">
                                <div class="timeline-dot"></div>
                                <div class="timeline-content">
                                    {{hist.fecha | date: 'dd/MM/yyy HH:mm:ss'}} - {{hist.descripcion}}: {{hist.nom_mat}}{{hist.nombre_bg}}, Cantidad: {{hist.cantidad}}, {{hist.usuario}}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>

